<template>
  <div class="notice">
    <div class="title">
      <h1>{{ $route.meta.title }}</h1>
      <span></span>
    </div>
    <div class="News" v-if="!isDetails">
      <h3 class="null" v-if="newList.length <= 0">暂无资讯...</h3>
      <ul class="content" v-else>
        <li
          v-for="item in newList"
          :key="item.news_id"
          @click="ToDetailHandle(item.id)"
        >
          <div class="left">
            <img :src="item.cover_image" alt="" />
          </div>
          <div class="right">
            <h3>{{ item.title }}</h3>
            <div class="pblock">
              <div class="span">{{ item.publish_time }}</div>
              <div class="span">阅读量：&nbsp; {{ item.view_count }}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="NewsDetails" v-else>
      <div class="detailsTitle">
        <span @click="gobackClick()">{{ $route.meta.title }}</span> /
        <span style="color: #05258e">{{ newsdetail.title }}</span>
      </div>
      <div class="contentBox">
        <div class="left">
          <!-- <h2>{{ newsdetail.title }}</h2> -->
          <div class="info flex_layout">
            <span class="time">{{ newsdetail.publish_time }}</span>
            <span>阅读：{{ newsdetail.view_count }}</span>
          </div>
          <div class="border"></div>
          <div class="content">
            <div
              class="contenthtml"
              ref="contenthtml"
              v-html="newsdetail.content"
            ></div>
            <p>
              {{ newsdetail.summary }}
            </p>
            <!-- 报名按钮 -->
            <div class="btnbox">
              <div class="signbtn text-center" @click="openSignDialog">
                立即报名
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 对话框 -->
    <el-dialog
      title="报名"
      :visible.sync="SignDialog"
      :width="isMobile ? '100%' : '40%'"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
    >
      <div class="mobileblock">
        <signModule :hasRegistered="hasRegistered"></signModule>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import signModule from "../../components/signModule.vue";
import nullPageModule from "../../components/nullPageModule.vue";
import { hasToken } from "../../assets/js/storage";
import { getRegistrationInfo } from "../API/user";
import { getNewList, getNewDetails } from "../API/new";

export default {
  components: {
    nullPageModule,
    signModule,
  },
  props: {},
  data() {
    return {
      hasRegistered: false,
      SignDialog: false,
      isMobile: document.body.clientWidth < 540 ? true : false,
      newList: [],
      newsdetail: {},
      isDetails: false,
      srcList: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getNewListHandle();
  },
  mounted() {},
  methods: {
    async getNewListHandle() {
      const res = await getNewList("page=1&limit=99");
      this.newList = res.data.data.list;
      this.filtersrcList();
    },
    filtersrcList() {
      this.srcList = this.newList.map((item) => item.RedheadeduRL);
    },
    openSignDialog() {
      if (hasToken()) {
        // 检测报名状态
        this.getReInfo();
      } else {
        this.$emit("openLoginDialog");
        this.$message.warning("请您先登录");
      }
    },
    handleClose() {
      this.SignDialog = false;
    },
    // 检测报名状态
    async getReInfo() {
      let isUserInfo = localStorage.getItem("UserInfo") ? true : false;
      const { data: res } = await getRegistrationInfo();
      this.hasRegistered = res.data.hasRegistered;
      if (!this.hasRegistered) {
        if (!isUserInfo) {
          this.$message.warning("您还未绑定手机号");
          return this.$emit("openbindDialog");
        } else {
          this.SignDialog = true;
        }
      } else {
        return this.$message.warning("您已经报名过了");
      }
    },
    async ToDetailHandle(id) {
      this.isDetails = true;
      const res = await getNewDetails(id);
      this.newsdetail = {
        ...res.data.data,
        content: this.addStyleToImg(res.data.data.content),
      };
    },
    gobackClick() {
      this.isDetails = false;
      this.getNewListHandle();
    },
    addStyleToImg(htmlString) {
      return htmlString.replace(/<img\b([^>]*)>/gi, (match, attrs) => {
        // 已有 style 属性
        if (/\bstyle\s*=\s*(['"])(.*?)\1/i.test(attrs)) {
          return match.replace(/\bstyle\s*=\s*(['"])(.*?)\1/i, (m, q, val) => {
            // 检查是否已有 width
            const newVal = /(^|;)\s*width\s*:/i.test(val)
              ? val
              : `${val.replace(/;\s*$/, "")}; width: 100%`;
            return `style=${q}${newVal}${q}`;
          });
        }
        return `<img${attrs} style="width: 100%">`;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.notice {
  width: 62%;
  margin: 0 auto;
  min-height: 500px;
  padding-bottom: 30px;
  background: #ffffff;
  box-sizing: border-box;
  @media screen and (max-width: 540px) {
    width: 100%;
    padding: 0 30px;
  }
  .mobileblock {
    padding: 20px 14px;
  }
  .title {
    padding: 50px 0 20px 0;
    width: 100%;
    h1 {
      font-size: 26px;
      text-align: center;
      color: #05258e;
      padding-bottom: 10px;
    }
    span {
      display: block;
      margin: 0px auto;
      width: 24px;
      height: 4px;
      background: #05258e;
      border-radius: 2px;
    }
  }
  .NewsDetails {
    width: 100%;
    .btnbox {
      padding: 50px 0;
      .signbtn {
        margin: auto;
        width: 248px;
        height: 60px;
        line-height: 60px;
        background: linear-gradient(86deg, #6f44a1 0%, #05258e 100%);
        box-shadow: 0px 8px 17px 0px #c3cbe5;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid;
        font-weight: bold;
        font-size: 18px;
        text-align: center;
        cursor: pointer;
        color: #ffffff;
        border-image: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.5),
            rgba(255, 255, 255, 1)
          )
          1 1;
      }
    }
    .detailsTitle {
      font-size: 20px;
      color: #666;
      padding: 30px 0 18px 0;
      margin: 0 auto;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      @media screen and (max-width: 540px) {
        text-align: center;
        width: 100%;
        font-size: 15px;
        box-sizing: border-box;
      }
      span {
        cursor: pointer;
      }
    }
    .contentBox {
      flex: 1;
      width: 100%;
      background-color: #fff;
      padding: 40px 60px;
      box-sizing: border-box;
      margin: 0 auto;
      display: flex;
      @media screen and (max-width: 540px) {
        display: block;
        width: 100%;
        padding: 0;
      }
      .left {
        width: 100%;
        h2 {
          font-size: 34px;
          text-align: center;
          color: #333333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          @media screen and (max-width: 540px) {
            font-size: 18px;
            text-align: center;
            padding-top: 15px;
          }
        }
        .info {
          color: #666;
          font-size: 18px;
          text-align: center;
          padding: 20px 0 30px 0;
          justify-content: space-between;
          @media screen and (max-width: 540px) {
            padding: 14px 0 20px 0;
            font-size: 13px;
          }
          .time {
            padding-right: 50px;
          }
        }
        .border {
          height: 1px;
          background-color: #eeeeee;
          width: 100%;
          margin-bottom: 30px;
          @media screen and (max-width: 540px) {
            display: none;
          }
        }
        .pic {
          width: 100%;
          margin-bottom: 60px;
          @media screen and (max-width: 540px) {
            margin-bottom: 20px;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
        .newscontent {
          color: #666;
          font-size: 20px;
          text-align: center;
          img {
            width: 100% !important;
          }
          p {
            line-height: 43px;
            @media screen and (max-width: 540px) {
              font-size: 14px;
              text-indent: 0;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
  .News {
    .null {
      text-align: center;
      font-size: 30px;
      padding: 200px 0;
    }
    .content {
      width: 100%;
      margin: 0px auto;
      padding-top: 80px;
      margin-bottom: 180px;
      @media screen and (max-width: 540px) {
        padding: 20px 0 40px 0;
        box-sizing: border-box;
        margin: 0;
      }
      img {
        width: 100%;
        height: 100%;
      }
      li {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
        cursor: pointer;
        width: 100%;

        .left {
          flex-basis: 200px;
          width: 200px;
          height: 113px;
          margin-right: 30px;
          @media screen and (max-width: 540px) {
            flex-basis: 100px;
            width: 100px;
            height: 60px;
            margin-right: 10px;
          }
          img {
            width: 100%;
            height: 100%;
            @media screen and (max-width: 540px) {
              width: 100px;
            }
          }
        }
        .right {
          flex: 1;
          @media screen and (max-width: 540px) {
          }
          .pblock {
            padding: 17px 0;
            display: flex;
            justify-content: space-between;
            @media screen and (max-width: 540px) {
              padding: 5px 0 10px 0;
              font-size: 14px;
            }
            .span {
              display: block;
              font-size: 16px;
              color: #666;
              @media screen and (max-width: 540px) {
                font-size: 12px;
              }
            }
          }
          h3 {
            padding: 17px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            @media screen and (max-width: 540px) {
              padding: 5px 0 10px 0;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
